import { gql } from 'apollo-angular';

export class CategoriesQueries {
  public static getCategories = gql`
    query configuratorFpcs {
      configuratorFpcs {
        presignedUrl
      }
    }
  `;
}
